import { Component } from '@theme/component';

/**
 * Oath PDP Product Story Tabs — accordion list that swaps a shared media pane.
 *
 * Built on Horizon's Component base + ref system (same convention as marquee.js), per the
 * S25 native-conventions-based doctrine. Figma 877:11934 / 1222:3452. Single source of truth
 * = the active index; clicking a row opens its description AND shows its media (no src-swap —
 * all media render stacked, we toggle .is-active). First row open by default.
 *
 * @typedef {object} Refs
 * @property {HTMLElement[]} row - the accordion row buttons (ref="row[]")
 * @property {HTMLElement[]} media - the stacked media items (ref="media[]")
 * @extends Component<Refs>
 */
class OathStoryTabs extends Component {
  requiredRefs = ['row', 'media'];

  connectedCallback() {
    super.connectedCallback();
    const { row } = this.refs;
    if (!row || row.length === 0) return;
    row.forEach((btn, i) => {
      btn.addEventListener('click', () => this.#activate(i));
    });
    this.#activate(0);
  }

  /**
   * @param {number} index
   */
  #activate(index) {
    const { row, media } = this.refs;

    row.forEach((btn, i) => {
      const isActive = i === index;
      btn.setAttribute('aria-expanded', isActive ? 'true' : 'false');
      const rowEl = btn.closest('.oath-story-tabs__row');
      if (rowEl) rowEl.classList.toggle('is-active', isActive);
    });

    media.forEach((item, i) => {
      item.classList.toggle('is-active', i === index);
    });
  }
}

if (!customElements.get('oath-story-tabs')) {
  customElements.define('oath-story-tabs', OathStoryTabs);
}
